// extracted by mini-css-extract-plugin
export default {"changelogcontainer":"MenuPage_changelogcontainer__mopBk","changelogbutton":"MenuPage_changelogbutton__qHHhV","logo":"MenuPage_logo__cVNWR"};